export const ModalStyle = {
    defaultStyle: {
        content: {
            // sizing: let content determine height, but limit it so it fits the viewport
            width: '90vw',
            overflow: 'scroll',
            maxHeight: '90vh',

            // small default padding
            padding: '1rem',

            // visual polish
            background: '#ffffff',
            borderRadius: '10px',
            boxShadow: '0 12px 30px rgba(16,24,40,0.18), 0 4px 8px rgba(16,24,40,0.06)',
            left: "auto",
            bottom: "auto",
        },
        overlay: {
            // ensure overlay covers full screen and modal is visually centered
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            zIndex: 1000,
            // display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            // subtle blur for a modern backdrop (supported in most modern browsers)
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            overflow: 'scroll'
        },
    }
}
export default ModalStyle;